export default __webpack_public_path__ + "static/media/Button_4-min.3e7dedd2.png";